import PropTypes from 'prop-types';
import ImageProp from '../../../commonComponents/propTypes/imageProp';

const propType = {
  name: PropTypes.string,
  info: PropTypes.string,
  logo: PropTypes.shape(ImageProp.propType),
  backgroundColor: PropTypes.string,
  textColor: PropTypes.string,
};

export default { propType };
